import React from 'react'
import { createRoot } from 'react-dom/client'
import AuthenticatedDropdownAdvisor from './AuthenticatedDropdownAdvisor.jsx'
import AuthenticatedDropdownInvestor from './AuthenticatedDropdownInvestor.jsx'
import AuthenticatedDropdownInstitutional from './AuthenticatedDropdownInstitutional.jsx'

class MobileAuthenticatedDropdownElement extends HTMLElement {
  connectedCallback() {
    const reactContainerId = 'mobile-authenticated-dropdown-react-app'
    const reactContainer = document.createElement('div')
    const site = this.getAttribute('site')

    reactContainer.setAttribute('id', reactContainerId)
    this.appendChild(reactContainer)

    const container = document.getElementById(reactContainerId)
    const root = createRoot(container)

    if (site && site.includes('investor')) {
      root.render(<AuthenticatedDropdownInvestor />)
    } else if (site && site.includes('institutional')) {
      root.render(<AuthenticatedDropdownInstitutional mobile />)
    } else {
      root.render(<AuthenticatedDropdownAdvisor mobile />)
    }
  }
}

customElements.define(
  'mobile-authenticated-dropdown',
  MobileAuthenticatedDropdownElement
)
